import React, { useState } from 'react';
import RoomTariffTable from './Components/RoomTariffTable'; 
import AddRoomTariff from './Components/AddRoomTariff';     

const RoomTariff = () => {
  const [showModal, setShowModal] = useState(false);

  const handleAddRoom = (newRoomData) => {
   
    setShowModal(false);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room Tariff</h3>
            <button className="btn btn-dark" onClick={() => setShowModal(true)}>
              + Add Tariff
            </button>
          </div>
        </div>

        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <RoomTariffTable />
            </div>
          </div>
        </div>
      </div>

      <AddRoomTariff
        show={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleAddRoom}
      />
    </div>
  );
};

export default RoomTariff;
